(function () {
    'use strict';

    angular.module('eDocumentsApp').controller('DocumentsExternalController', DocumentsExternalController);

    DocumentsExternalController.$inject = ['$stateParams', '$filter', 'Document', 'DocumentDownloadPdf', 'DataUtils', 'CurrencyUtils'];

    function DocumentsExternalController($stateParams, $filter, Document, DocumentDownloadPdf, DataUtils, CurrencyUtils) {
        var vm = this;

        vm.hashMissing = angular.isUndefined($stateParams.hash);
        vm.hash = $stateParams.hash;
        vm.linkExpired = false;
        vm.error = null;
        vm.download = download;
        vm.downloadAllFiles = downloadAllFiles;
        vm.getFileIconClass = DataUtils.getFileIconClass;
        // the template calls it for each document's value; undefined, the currency filter fell back to the locale's symbol
        vm.getCurrency = CurrencyUtils.getCurrency;
        vm.success = null;
        vm.externalDocuments = null;
        vm.approvalInfoOf = approvalInfoOf;

        Document.getAllByExternalHash(
            {
                hash: $stateParams.hash,
            },
      function (result) {
          vm.externalDocuments = result;
      },
      function (error) {
          vm.externalDocuments = null;
          vm.error = error;
          // EDOCS-378: an expired link is not an error to show, it is a state with a way out
          vm.linkExpired = error && error.status === 410;
      }
    );

        /** #19: the approval tooltip reads "03/11/2026 12:11" in the reader's time zone, never the raw ISO instant. */
        function approvalInfoOf(document) {
            return {
                approvedBy: document.approvedBy,
                approvedDate: document.approvedDate ? $filter('date')(document.approvedDate, 'dd/MM/yyyy HH:mm') : '',
            };
        }

        function download($event, document, fileHashedId) {
            DocumentDownloadPdf.downloadExternal($event, document, fileHashedId);
        }

        function downloadAllFiles($event) {
            DocumentDownloadPdf.downloadAllFilesExternal($event, $stateParams.hash, vm.externalDocuments);
        }
    }
})();
